module.exports = __webpack_public_path__ + "img/9.8.TSS.da25886b.png";